// extracted by mini-css-extract-plugin
export default {"form-container":"style_form-container__sdWCg"};